/** UI synchronization only: authentication and tenant authorization stay on the server. */
export function tokenSessionIdentity(token: string | null): string | null {
  if (!token) return null;
  try {
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(encoded));
    if (typeof payload.sub !== 'string') return null;
    return JSON.stringify([payload.sub, payload.tenant_id || null, !!payload.impersonating]);
  } catch { return null; }
}

export function subscribeToSessionChanges(identity: string, onChange: () => void): () => void {
  let changed = false;
  const check = () => {
    if (!changed && tokenSessionIdentity(localStorage.getItem('access_token')) !== identity) {
      changed = true;
      onChange();
    }
  };
  const storage = (event: StorageEvent) => {
    if (event.storageArea === localStorage && (event.key === 'access_token' || event.key === null)) check();
  };
  window.addEventListener('storage', storage);
  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', check);
  check();
  return () => {
    window.removeEventListener('storage', storage);
    window.removeEventListener('focus', check);
    document.removeEventListener('visibilitychange', check);
  };
}
